<div class="flex min-h-0 flex-1 flex-col gap-8">
  <lib-baa-scroll-container>
    <div
      class="flex flex-col items-center gap-2 rounded-3xl bg-gradient-to-br from-[#f8fcff] to-[#f0f8ff] px-4 py-5"
    >
      <img src="assets/images/ffd-notes-sign-up-modal/baa-sign.png" alt="" class="h-[160px] w-[220px]" />

      <div class="typo-h2 text-center text-text-primary">{{ 'express_app_baa_success_heading' | translate }}</div>
      <div class="typo-h4-light font-light text-text-secondary">{{ 'express_app_baa_success_description' | translate }}</div>
    </div>
  </lib-baa-scroll-container>
  <button
    class="btn-primary w-full shrink-0 justify-center bg-primary-blue px-10 py-2.5 active:bg-primary-blue"
    type="button"
    (click)="onReturnClick()"
  >
    {{ 'express_app_baa_success_return_button' | translate }}
  </button>
</div>
